import { StatusIndicatorColorEnum } from '@inter-ikea-kompis/enums';
export default StatusIndicatorColorEnum;
